import { render, staticRenderFns } from "./IconDuplicate.vue?vue&type=template&id=08442996&"
import script from "./IconDuplicate.vue?vue&type=script&lang=js&"
export * from "./IconDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08442996')) {
      api.createRecord('08442996', component.options)
    } else {
      api.reload('08442996', component.options)
    }
    module.hot.accept("./IconDuplicate.vue?vue&type=template&id=08442996&", function () {
      api.rerender('08442996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDuplicate.vue"
export default component.exports